// extracted by mini-css-extract-plugin
export var columns = "Calculation-module--columns--a5b73";
export var desktop = "Calculation-module--desktop--6da61";
export var impact = "Calculation-module--impact--95112";
export var mobile = "Calculation-module--mobile--6f19d";
export var original = "Calculation-module--original--73a17";
export var result = "Calculation-module--result--fb4db";